import TextArea from 'common/components/TextArea';
import { ObservableField as Field, ObservableForm } from 'projects/components/ObservableForm';
import React from 'react';

interface Fields {
    description: string;
}

interface Props<T> {
    form: ObservableForm<T>;
    placeholderText?: string;
}

const DescriptionField: <T extends Fields>(props: Props<T>) => React.ReactElement<Props<T>> = ({
    form,
    placeholderText,
}) => {
    return (
        <Field
            form={form}
            name="description"
            title={__('Describe your project')}
            tooltip={__(
                'Include as many details as possible, like styles, images, colors, fonts and technical specifications. Be concise and use bullet points to make it simple for your designer to understand.'
            )}
            required={true}
            render={() => (
                <TextArea
                    style={{ minHeight: 200 }}
                    placeholder={placeholderText}
                    fill={true}
                    {...form.attach('description')}
                />
            )}
        />
    );
};

export default DescriptionField;
